/* eslint-disabled */
import Avenant from "./Avenant";
import Branch from "./Branch";
import Feature from "./Feature";
import TypeAvenantExtend from "@/entity/extends/TypeAvenantExtend";
import Insurer from "./Insurer";
import { hydrateCollection, toArray } from "@/Utils/EntityHelper";

export default class TypeAvenant extends TypeAvenantExtend {


public id!: number;
public code = '';
public label = '';
public primeImpact!: boolean;
public allRisks!: boolean;
public avenants: Array<Avenant> = [];
public feature: Array<Feature> = [];
public description? = '';
public lastFunction? = '';
public calculPrimeFunction? = '';
public insurers: Array<{
    label:string,
    id: number,
}> = [];
public branchs: Array<Branch> = [];

  constructor (object?: any) {
      super(object)
      if(object){
        this.id = object.id
       this.code= object.code;
       this.label= object.label;
       this.primeImpact= object.primeImpact;
       this.allRisks= object.allRisks;
            hydrateCollection(object.avenants, Avenant, this.avenants);
            hydrateCollection(object.feature, Feature, this.feature);
       toArray(object.insurers).forEach((occ: any) => {
           if (typeof occ === 'object') {
               this.insurers.push({ label: occ.label, id: occ.id });
           }
       });
       hydrateCollection(object.branchs, Branch, this.branchs);
       this.description= object.description;
       this.lastFunction= object.lastFunction;
       this.calculPrimeFunction= object.calculPrimeFunction;
      }
      this.postConstruct()
  }

}
